import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { Collapse } from 'reactstrap';
import Message from './model/Message';

interface IMessagePreviewMobileProps {
  message: Message;
  isOpen: boolean;
  showNoImagesBanner: boolean;
  htmlBody: string;
  attachments: string[];
}

export class MessagePreviewMobile extends React.Component<IMessagePreviewMobileProps> {
  constructor(props: IMessagePreviewMobileProps) {
    super(props);
  }

  public render() {
    const message = this.props.message;
    const htmlBody = { __html: this.props.htmlBody };
    const attachments = this.props.attachments.map((fileName, index) => {
      return (
        <div className="row attachment-container-mobile" key={index}>
          <div className="col-12">
            <span className="attachment-file-mobile">
              <i className="material-icons attachment">
                attach_file
              </i>{fileName}
            </span>
          </div>
        </div>
      )
    });
    return (
      <Collapse isOpen={this.props.isOpen}>
        <div id="narrow-results" className="narrow-results">
          <div className="row">
            <div className="col-12">
              {this.props.showNoImagesBanner && <div className="alert alert-primary alert-dismissible fade show row align-items-center justify-content-between" role="alert" id="noImagesBanner">
                <span>
                  <i className="material-icons">info</i>
                  <FormattedMessage id="L.ImagesNotDisplayed" defaultMessage="Images Not Displayed" />
                </span>
              </div>}

              <div dangerouslySetInnerHTML={htmlBody} />

              {message.hasAttachment && <div className="row" id="attachments">
                <div className="col-12 attach-header">
                  <h6> <FormattedMessage id="L.Attachments" defaultMessage="Attachments" /></h6>
                </div>
              </div>}
              {message.hasAttachment && attachments}
            </div>
          </div>
        </div>
      </Collapse >
    );
  }
}

export default MessagePreviewMobile;


// WEBPACK FOOTER //
// ./src/components/mail/MessagePreviewMobile.tsx